module.exports = __webpack_public_path__ + "img/06-SUV-Geländewagen-Pickup.f2f26095.svg";